import React, { useEffect } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap'
import _ from 'lodash'
import { compose } from 'redux'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import Typeahead from 'components/Typeahead'

import WithCountries from 'actions/dictionary/countries'
import WithStates from 'actions/dictionary/states'
import WithCities from 'actions/dictionary/cities'

const Create = ({
  showCreateBranch,
  onChangeBranchesHOC,
  newBranch,
  createBranch,
  onLoadBranches,
  selectedCompany,
  onLoadCountries,
  countries,
  getCountries,
  onLoadStates,
  states,
  getStates,
  onLoadCities,
  cities,
  getCities
}) => {

  useEffect(() => {
    if( showCreateBranch ) {
      getCountries()
    }
  }, [ showCreateBranch ])

  const onChangeBranchData = ( key, val ) => {
    let tmp = _.cloneDeep( newBranch )
    tmp[ key ] = val
    return onChangeBranchesHOC( 'newBranch', tmp )
  }

  return (
    <Modal
      isOpen={ showCreateBranch }
      size={ 'md' }
      toggle={() => onChangeBranchesHOC( 'showCreateBranch', false )}>
      <ModalHeader toggle={() => onChangeBranchesHOC( 'showCreateBranch', false )}>Create branch</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              value={ newBranch.name }
              onChange={ e => {
                onChangeBranchData( 'name', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>Address</Label>
            <Input
              type="text"
              value={ newBranch.address }
              onChange={ e => {
                onChangeBranchData( 'address', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>Country</Label>
            <Typeahead
              id={ 'country' }
              multiple={ false }
              options={ countries }
              onSelect={ val => {
                if( val && val.length > 0 ) {
                  onChangeBranchData( 'country', val[ 0 ].code )
                  getStates( val[ 0 ].code )
                } else {
                  onChangeBranchData( 'country', '' )
                }
              }}
              selectedValue={ _.find( countries, { id: newBranch.country }) ? [ _.find( countries, { id: newBranch.country }) ] : [] } />
          </FormGroup>
          <FormGroup>
            <Label>State</Label>
            <Input
              type="select"
              value={ newBranch.state }
              onChange={ e => {
                onChangeBranchData( 'state', e.target.value )
                getCities( newBranch.country, e.target.value )
              }}>
              <option></option>
              {
                states && states.map( item => {
                  return <option key={ item.code } value={ item.code }>{ item.name }</option>
                })
              }
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Postcode</Label>
            <Input
              type="text"
              value={ newBranch.postcode }
              onChange={ e => {
                onChangeBranchData( 'postcode', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>City</Label>
            <Input
              type="select"
              value={ newBranch.city }
              onChange={ e => {
                onChangeBranchData( 'city', e.target.value )
              }}>
              <option></option>
              {
                cities && cities.map( item => {
                  return <option key={ item.code } value={ item.code }>{ item.code }</option>
                })
              }
            </Input>
          </FormGroup>
        </Form>
        { ( onLoadBranches || onLoadCountries || onLoadStates || onLoadCities ) && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary" 
          onClick={() => {
            let tmp = _.cloneDeep( newBranch )
            tmp.company_id = selectedCompany.id
            createBranch( tmp )
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default compose(
  WithCountries,
  WithStates,
  WithCities
)( Create )